import { z } from 'zod';
import { normalizeDateTimeQuestionConfig } from './question-blocks';

/** Shared authoring and respondent config boundary, with semantic validation. */
const bound = z.discriminatedUnion('source', [
  z.object({ source: z.literal('today'), offsetDays: z.number().int().min(-36500).max(36500) }).strict(),
  z.object({ source: z.literal('answer'), fieldId: z.string().min(1).max(200), offsetDays: z.number().int().min(-36500).max(36500) }).strict(),
]);

/** Keep all date configuration boundaries aligned with the shared runtime validator. */
export const dateTimeQuestionConfigSchema = z.object({
  mode: z.enum(['date', 'time', 'date_time']),
  min: z.string().max(16).optional(),
  max: z.string().max(16).optional(),
  rules: z.object({
    timezone: z.string().min(1).max(100),
    allowedWeekdays: z.array(z.number().int().min(0).max(6)).min(1).max(7).optional(),
    excludedDates: z.array(z.string().length(10)).max(366).optional(),
    includedDates: z.array(z.string().length(10)).max(366).optional(),
    min: bound.optional(), max: bound.optional(),
  }).strict().optional(),
}).strict().refine(value => normalizeDateTimeQuestionConfig(value) !== undefined);
